import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Checkbox, Form, FormGroup, Panel, Col} from 'react-bootstrap';
import Modal from '../modal-shim';
import {Field, reduxForm} from 'redux-form';
import {InputField} from './InputField';
import {validation} from '../validation';
import Recaptcha from './Recaptcha';
import TermsOfService from './TermsOfService'
import Error from './Error';
import ModalContainer from '../containers/ModalContainer';

const validate = validation({
    firstName: {
        required: true,
    },
    lastName: {
        required: true,
    },
    email: {
        required: true,
    },
    password: {
        required: true,
        password: true,
        confirm: 'confirmPassword',
    },
    confirmPassword: {
        required: true,
    },
});

@reduxForm({form: 'Registration', validate})
export default class Registration extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func, // passed by redux-form
        agreed: PropTypes.bool,
        error: PropTypes.any,
        captchaResponse: PropTypes.string,
        onCaptchaResponse: PropTypes.func,
        onToggleAgreeServiceTerms: PropTypes.func,
    };

    componentWillReceiveProps(nextProps) {
        if (this.props.captchaResponse && !nextProps.captchaResponse) {
            this.recaptcha.reset();
        }
    }

    render() {
        const {agreed, captchaResponse, error, handleSubmit, onToggleAgreeServiceTerms, onCaptchaResponse} = this.props;

        return (
            <Panel header={'Registration'}>
                {error && <Error error={error}/>}
                <Form onSubmit={handleSubmit} style={{margin: 'auto', width: 600}} horizontal className="user-edit">
                    <Field type="text" name="firstName" component={InputField} label="First Name" required autoFocus/>
                    <Field type="text" name="lastName" component={InputField} label="Last Name" required/>
                    <Field type="text" name="email" component={InputField} label="Email" required autoComplete="off"/>
                    <Field type="password" name="password" component={InputField} label="Password" required autoComplete="off"/>
                    <Field type="password" name="confirmPassword" component={InputField} label="Confirm password" required autoComplete="off"/>
                    <FormGroup>
                        <Col mdOffset={3} md={9}>
                            <ModalContainer name="serviceModal">{(isOpen, openModal, closeModal) => (
                                <Checkbox onChange={onToggleAgreeServiceTerms}>
                                    <a onClick={openModal}>{'I agree with the terms of the service agreement'}</a>
                                    <Modal bsSize="lg" show={isOpen} onHide={closeModal} className="termsModal">
                                        <Modal.Header closeButton/>
                                        <Modal.Body>
                                            <TermsOfService/>
                                        </Modal.Body>
                                    </Modal>
                                </Checkbox>
                            )}</ModalContainer>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col mdOffset={3} md={9} style={{marginTop: 10}}>
                            <Recaptcha
                                ref={c => this.recaptcha = c}
                                verifyCallback={onCaptchaResponse}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col mdOffset={3} md={9}>
                            <Button type="submit" bsStyle="primary" className="registerBtn" disabled={!agreed || !captchaResponse}>{'REGISTER'}</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </Panel>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Registration.js